import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 设计项目列表
export const setInspectionPages: Mutation<IModuleState> = (state, payload) => {
  state.inspectionPage.data = payload.data;
  state.inspectionPage.total = payload.total;
  state.inspectionPage.pageNum = payload.pageNum;
  state.inspectionPage.pageSize = payload.pageSize;
  state.inspectionPage.loading = !!payload.loading;
};

// 设计项目详情
export const setInspectionDetail: Mutation<IModuleState> = (state, payload) => {
  state.inspectionDetail.data = payload.data;
  state.inspectionDetail.loading = !!payload.loading;
};

// 反馈信息列表
export const setFeedbackList: Mutation<IModuleState> = (state, payload) => {
  state.feedbackList.data = payload.data;
  state.feedbackList.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
